import { Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_NUMERICTEXTBOX, KENDO_TEXTBOX } from "@progress/kendo-angular-inputs";
import { ChangedFieldDirective } from "../../changed-field.directive";
import { HookArray } from "./hook-group";

/** The hooks mounted on the flight: what it used of each, by its serial and name. */
@Component({
    selector: "app-hook-tab",
    imports: [ChangedFieldDirective, ReactiveFormsModule, TranslatePipe, KENDO_NUMERICTEXTBOX, KENDO_TEXTBOX],
    templateUrl: "./hook-tab.component.html",
    styleUrl: "../../edit-fields.scss",
})
export class HookTabComponent {
    readonly rows = input.required<HookArray>();
    /** Each hook by its serial and name, or whichever of the two the logbook has. */
    readonly labels = input.required<string[]>();
}
